module.exports = __webpack_public_path__ + "img/b2.2d7be69.png";